import { createSlice } from 'src/models/applicant/resume/lib/slice';
import { ReducerAction } from 'src/models/applicant/resume/lib/slice/types';

type SnackbarType = 'success' | 'error';

interface MisleadingVacancyAlertStore {
    employerId?: number;
    savingToBlackList: boolean;
    // Модал, который показываем при нажатии на бэйдж в карточке компании
    modal: {
        visibility: boolean;
    };
    snackbar: {
        type?: SnackbarType;
        visibility: boolean;
    };
}

const initialState: MisleadingVacancyAlertStore = {
    savingToBlackList: false,
    modal: {
        visibility: false,
    },
    snackbar: {
        visibility: false,
    },
};

const misleadingVacancyAlertSlice = createSlice({
    initialState,
    reducers: {
        toggleMisleadingVacancyModalVisibility: (state, { payload }: ReducerAction<boolean>) => ({
            ...state,
            modal: {
                visibility: payload,
            },
        }),
        toggleSavingToBlackList: (state, { payload }: ReducerAction<boolean>) => ({
            ...state,
            savingToBlackList: payload,
        }),
        setMisleadingVacancyEmployerId: (state, { payload }: ReducerAction<number | undefined>) => ({
            ...state,
            employerId: payload,
        }),
        showMisleadingVacancySnackbar: (state, { payload }: ReducerAction<SnackbarType>) => ({
            ...state,
            snackbar: {
                visibility: true,
                type: payload,
            },
        }),
        hideMisleadingVacancySnackbar: (state) => ({
            ...state,
            snackbar: {
                visibility: false,
            },
        }),
    },
});

export const {
    toggleSavingToBlackList,
    hideMisleadingVacancySnackbar,
    showMisleadingVacancySnackbar,
    setMisleadingVacancyEmployerId,
    toggleMisleadingVacancyModalVisibility,
} = misleadingVacancyAlertSlice.actions;

export const misleadingVacancyAlertReducer = misleadingVacancyAlertSlice.reducer;
